<script>
export default {
    name: "ProcedureDetails",

    data() {

        return {
            procedureDetails: {
                personelnProcedureDetails: [],
                preOperativeNotes: [],
                operationNotes: [],
                postOperationNotes: [],
                anaesthesiaNotes: [],
            },
            patient: {},
            admissionDetails: {},
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([
            this.fetchPatient(), this.fetchProcedureDetails(), 
        ]).then(() => { 
            this.$root.loading=false; 
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { 
            this.$root.loading=false; 
        });
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatientWithWard`;
                url += `?PatientID=${this.$route.query.PatientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.patientDetails.length ?
                     response.data.patientDetails[0] : {};
                this.admissionDetails = response.data.admissionDetails.length ? 
                    response.data.admissionDetails[0] : {};
            }).catch(() => {});
        },

        fetchProcedureDetails() {
            let url = `Theatre/GetSpecifiCompletedProcedureDetails`;
                url += `?ProcedureID=${this.$route.query.ProcedureID}`

            return this.$http.get(url).then(response => {
                this.procedureDetails = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex-wrap mx-2">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-wrap p-1 my-1 border-b-2 border-t-2 border-gray-800">
            <div class="w-1/4">
                <h5 class="text-base"><span class="font-medium">Name:</span> 
                    {{ patient.names }}</h5>
            </div>
            <div class="w-1/4">
                <h5 class="text-base"><span class="font-medium">IP File No:</span> 
                {{ patient.ipfileno || `-` }}</h5>
            </div>
            <div class="w-1/4">
                <h5 class="text-base"><span class="font-medium">OP File No:</span> 
                {{ patient.opfileno || `-` }}</h5>
            </div>
            <div class="w-1/4">
                <h5 class="text-base"><span class="font-medium">Visit No:</span> 
                {{ patient.visitNo || `-` }}</h5>
            </div>
            <div class="w-1/4">
                <h5 class="text-base"><span class="font-medium">MRN:</span> 
                    {{ patient.patienT_ID }}</h5>
            </div>
            <div class="w-1/4">
                <h5 class="text-base"><span class="font-medium">Age:</span> 
                    {{ patient.dob | numberOfYears }}</h5>
            </div>
            <div class="w-1/4">
                <h5 class="text-base"><span class="font-medium">Gender:</span> 
                    {{ patient.gender }}</h5>
            </div>
            <div class="w-1/4">
                <h5 class="text-base"><span class="font-medium">Ward:</span> 
                    {{ admissionDetails.ward || `-` }}</h5>
            </div>
            <div class="w-1/4">
                <h5 class="text-base"><span class="font-medium">Bed:</span> 
                    {{ admissionDetails.bed || `-` }}</h5>
            </div>
        </div>
        <div class="w-full text-center p-1 my-3 border-b-2 border-gray-300">
            <h5 class="text-base font-bold uppercase">
                {{ 
                    procedureDetails.personelnProcedureDetails.length ?
                        procedureDetails.personelnProcedureDetails[0].procedure || `-` 
                    : `-`
                }}
            </h5>
        </div>
        <div class="w-full flex flex-wrap">
            <div class="w-full p-tiny text-center border-b-2 border-gray-300">
                <h5 class="font-bold text-base uppercase">Personnel</h5>
            </div>
            <div class="w-1/3 p-1">
                    <h5 class="font-medium text-sm">Operation Room: 
                       {{ 
                           procedureDetails.personelnProcedureDetails.length ?
                                procedureDetails.personelnProcedureDetails[0].operationRoom || `-` 
                            : `-` 
                        }}
                       </h5>
                </div>
                <div class="w-1/3 p-1">
                    <h5 class="font-medium text-sm">Surgeon: 
                       {{ 
                           procedureDetails.personelnProcedureDetails.length ?
                                procedureDetails.personelnProcedureDetails[0].surgeon || `-` 
                            : `-` 
                        }}
                    </h5>
                </div>
                <div class="w-1/3 p-1">
                    <h5 class="font-medium text-sm">Assistant Surgeon:
                        {{ 
                            procedureDetails.personelnProcedureDetails.length ?
                                procedureDetails.personelnProcedureDetails[0].assistantSurgeon || `-` 
                            : `-`
                        }}
                    </h5>
                </div>
                <div class="w-1/3 p-1">
                    <h5 class="font-medium text-sm">Scrub Nurse:
                        {{ 
                            procedureDetails.personelnProcedureDetails.length ?
                                procedureDetails.personelnProcedureDetails[0].scrubNurse || `-` 
                            : `-`
                        }}
                    </h5>
                </div>
                <div class="w-1/3 p-1">
                    <h5 class="font-medium text-sm">Anaesthetist:
                        {{ 
                            procedureDetails.personelnProcedureDetails.length ?
                                procedureDetails.personelnProcedureDetails[0].anaesthetist || `-` 
                            : `-`
                        }}
                    </h5>
                </div>
                <div class="w-1/3 p-1">
                    <h5 class="font-medium text-sm">Type Of Anaesthesia:
                        {{ 
                            procedureDetails.personelnProcedureDetails.length ?
                                procedureDetails.personelnProcedureDetails[0].typeofAnaesthesia || `-` 
                            : `-`
                        }}
                    </h5>
                </div>
                <div class="w-1/3 p-1">
                    <h5 class="font-medium text-sm">Diagnosis:
                        {{ 
                            procedureDetails.personelnProcedureDetails.length ?
                                procedureDetails.personelnProcedureDetails[0].diagnosis || `-` 
                            : `-`
                        }}
                    </h5>
                </div>
        </div>
        <div class="w-full flex flex-wrap my-2">
            <div class="w-full text-center p-1 border-b-2 border-gray-300">
                <h5 class="text-base font-bold uppercase">Preoperative Notes</h5>
            </div>
            <div class="w-full p-tiny">
                <span v-html="procedureDetails.preOperativeNotes.length ?
                    procedureDetails.preOperativeNotes[0].preOperativeNotes || `-` : `-`"></span>
            </div>
        </div>
        <div class="w-full flex flex-wrap my-2">
            <div class="w-full text-center p-1 border-b-2 border-gray-300">
                <h5 class="text-base font-bold uppercase">Anaesthesia Notes</h5>
            </div>
            <div class="w-full p-tiny">
                <span v-html="procedureDetails.anaesthesiaNotes.length ?
                    procedureDetails.anaesthesiaNotes[0].anaesthesiaNotes || `-` : `-`"></span>
            </div>
        </div>
        <div class="w-full flex flex-wrap my-2">
            <div class="w-full text-center p-1 border-b-2 border-gray-300">
                <h5 class="text-base font-bold uppercase">Operation Notes</h5>
            </div>
            <div class="w-full p-tiny">
                <span v-html="procedureDetails.operationNotes.length ?
                    procedureDetails.operationNotes[0].operationNotes || `-` : `-`"></span>
            </div>
        </div>
        <div class="w-full flex flex-wrap my-2">
            <div class="w-full text-center p-1 border-b-2 border-gray-300">
                <h5 class="text-base font-bold uppercase">Postoperation Notes</h5>
            </div>
            <div class="w-full p-tiny">
                <span v-html="procedureDetails.postOperationNotes.length ?
                    procedureDetails.postOperationNotes[0].postOperationNotes || `-` : `-`"></span>
            </div>
        </div>
    </div>
</template>